'use strict';

import React from 'react';
import Utils from './Utils.js';


class DownloadComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick(params) {
        const object = this.props.data;
        let result = {};

        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                const element = object[key];
                const selector = element.selector;

                if (!result[selector]) {
                    result[selector] = Utils.transformCSS(element);
                }
                else {
                    result[selector] = result[selector] + Utils.transformCSS(element);
                }
            }
        }

        const cssOutput = Utils.generateCSS(result);

        this.download(cssOutput);
    }

    

    download(data) {
        var element = document.createElement("a");
        var file = new Blob([data], { type: 'text/css' });
        element.href = URL.createObjectURL(file);
        element.download = "skin.css";
        element.click();
    }

    render() {
        return (
         <a href="#" onClick={this.handleClick.bind(this)}  className="btn akamai-btn-orange-sm">skin.css</a>
        );
    }

}


export default DownloadComponent;
